import { Concept } from '../../models/Entities/Contracts/Concept';
import { CommonState } from '../common/state/commonState';

export interface ConceptState extends CommonState<Concept> {
  selected: Concept | undefined;
  isLoadingConceptSponsors: boolean;
}

export const ConceptUnloadState: ConceptState = {
  isLoadingAll: false,
  successLoadingAll: undefined,
  failOnLoadingAll: false,

  isLoadingOne: false,
  successLoadingOne: undefined,
  failOnLoadingOne: false,

  isAddingNewOne: false,
  successAddingNewOne: undefined,
  failOnAddingNewOne: false,

  isUpdatingOne: false,
  successUpdatingOne: undefined,
  failOnUpdatingOne: false,

  isDeletingOne: false,
  successDeletingOne: undefined,
  failOnDeletingOne: false,

  list: [],
  error: undefined,
  selected: undefined,
  isLoadingConceptSponsors: false
};
